// router/index.js 路由分配+路由守卫
// 导入Vue
import { createRouter, createWebHashHistory } from "vue-router";

// 创建路由的实例对象，定义路由规则，不需要写#
let router = createRouter({
  // 通过history属性，制定路由的工作模式
  history: createWebHashHistory(),
  
  // 滚动行为配置 - 每次路由跳转都滚动到页面顶端
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器前进/后退），则恢复到该位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则滚动到页面顶端
    return { top: 0, behavior: 'smooth' };
  },

  routes: [
    // ============ 移动端 ============  
    // ============ 移动端 home ============
    // 重定向规则
    { path: "/", redirect: "/index" },
    // 路由规则
    {
      path: "/index",
      component: () => import("../src/components/home/home_index.vue"),
      meta: { name: "home_index", requiresAuth: false },
    },

    // ============ 移动端 benefit ============
    { path: "/benefit", redirect: "/benefit/index" },
    {
      path: "/benefit/index",
      component: () => import("../src/components/benefit/benefit_index.vue"),
      meta: { name: "benefit_index", requiresAuth: false },
    },

    {
      path: "/benefit/login",
      component: () => import("../src/components/benefit/benefit_login.vue"),
      meta: { name: "benefit_login", requiresAuth: false },
    },

    {
      path: "/benefit/register",
      component: () => import("../src/components/benefit/benefit_register.vue"),
      meta: { name: "benefit_register", requiresAuth: false },
    },

    // ============ 移动端 encouragement ============
    // 重定向规则
    { path: "/encouragement", redirect: "/encouragement/index" },
    {
      path: "/encouragement/index",
      component: () =>
        import("../src/components/encouragement/encouragement_index.vue"),
      meta: { name: "encouragement_index", requiresAuth: false },
    },

    {
      path: "/encouragement/catagory_page",
      component: () =>
        import(
          "../src/components/encouragement/encouragement_catagory_page.vue"
        ),
      meta: { name: "encouragement_catagory_page", requiresAuth: false },
    },

    {
      path: "/encouragement/all",
      component: () =>
        import("../src/components/encouragement/encouragement_all.vue"),
      meta: { name: "encouragement_all", requiresAuth: false },
    },

    {
      path: "/encouragement/goods/sagol_er_1g",
      component: () =>
        import("../src/components/encouragement/goods/goods_sagol_er_1g.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },
    {
      path: "/encouragement/goods/sagol_er_4g6",
      component: () =>
        import("../src/components/encouragement/goods/goods_sagol_er_4g6.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },
    {
      path: "/encouragement/goods/reserve_er",
      component: () =>
        import("../src/components/encouragement/goods/goods_reserve_er.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },
    {
      path: "/encouragement/goods/grind_er",
      component: () =>
        import("../src/components/encouragement/goods/goods_grind_er.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },
    {
      path: "/encouragement/goods/brew_er",
      component: () =>
        import("../src/components/encouragement/goods/goods_brew_er.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },
    {
      path: "/encouragement/goods/adas_2g",
      component: () =>
        import("../src/components/encouragement/goods/goods_adas_2g.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },
    {
      path: "/encouragement/goods/adas_4g6",
      component: () =>
        import("../src/components/encouragement/goods/goods_adas_4g6.vue"),
      meta: { name: "encouragement_individual", requiresAuth: false },
    },

    // ============ 移动端 daily ============
    // 重定向规则
    { path: "/daily", redirect: "/daily/index" },
    {
      path: "/daily/index",
      component: () => import("../src/components/daily/daily_index.vue"),
      meta: { name: "daily_index", requiresAuth: false },
    },

    {
      path: "/daily/series",
      component: () => import("../src/components/daily/daily_series.vue"),
      meta: { name: "daily_series", requiresAuth: false },
    },

    {
      path: "/daily/play",
      component: () => import("../src/components/daily/daily_play.vue"),
      meta: { name: "daily_play", requiresAuth: false },
    },

    // ============ 移动端 network ============
    // 重定向规则
    { path: "/network", redirect: "/network/global" },
    { path: "/network/index", redirect: "/network/global" },
    {
      path: "/network/why_eyesunrose",
      component: () =>
        import("../src/components/network/network_why_eyesunrose.vue"),
      meta: { name: "network_why_eyesunrose", requiresAuth: false },
    },
    {
      path: "/network/why_eyesunrose/efficient",
      component: () =>
        import("../src/components/network/why_eyesunrose/n_we_efficient.vue"),
      meta: { name: "n_we_efficient", requiresAuth: false },
    },
    {
      path: "/network/why_eyesunrose/idea",
      component: () =>
        import("../src/components/network/why_eyesunrose/n_we_idea.vue"),
      meta: { name: "n_we_idea", requiresAuth: false },
    },
    {
      path: "/network/why_eyesunrose/place",
      component: () =>
        import("../src/components/network/why_eyesunrose/n_we_place.vue"),
      meta: { name: "n_we_place", requiresAuth: false },
    },
    {
      path: "/network/why_eyesunrose/ready",
      component: () =>
        import("../src/components/network/why_eyesunrose/n_we_ready.vue"),
      meta: { name: "n_we_ready", requiresAuth: false },
    },
    {
      path: "/network/why_eyesunrose/support",
      component: () =>
        import("../src/components/network/why_eyesunrose/n_we_support.vue"),
      meta: { name: "n_we_support", requiresAuth: false },
    },
    {
      path: "/network/why_eyesunrose/training",
      component: () =>
        import("../src/components/network/why_eyesunrose/n_we_training.vue"),
      meta: { name: "n_we_training", requiresAuth: false },
    },
    {
      path: "/network/apply_to_be_franchisee",
      component: () =>
        import("../src/components/network/network_apply_to_be_franchisee.vue"),
      meta: { name: "network_apply_to_be_franchisee", requiresAuth: false },
    },
    {
      path: "/network/ask_your_questions",
      component: () =>
        import("../src/components/network/network_ask_your_questions.vue"),
      meta: { name: "network_ask_your_questions", requiresAuth: false },
    },
    {
      path: "/network/franchisee_highlights",
      component: () =>
        import("../src/components/network/network_franchisee_highlights.vue"),
      meta: { name: "network_franchisee_highlights", requiresAuth: false },
    },
    // 重定向规则
    { path: "/network/application/form", redirect: "/network/application" },
    { path: "/network/application/index", redirect: "/network/application" },
    {
      path: "/network/application/newform",
      redirect: "/network/application/new",
    },
    {
      path: "/network/application/formnew",
      redirect: "/network/application/new",
    },
    {
      path: "/network/application/form/new",
      redirect: "/network/application/new",
    },
    {
      path: "/network/application",
      component: () =>
        import("../src/components/network/network_application_forms.vue"),
      meta: { name: "network_application_forms", requiresAuth: false },
    },
    {
      path: "/network/application/new",
      component: () =>
        import("../src/components/network/application/n_a_newform.vue"),
      meta: { name: "n_a_new", requiresAuth: false },
    },
    {
      path: "/network/application/sumit",
      component: () =>
        import("../src/components/network/application/n_a_sumit.vue"),
      meta: { name: "n_a_sumit", requiresAuth: false },
    },
    {
      path: "/network/application/track",
      component: () =>
        import("../src/components/network/application/n_a_track.vue"),
      meta: { name: "n_a_track", requiresAuth: false },
    },
    {
      path: "/network/application/backend",
      component: () =>
        import("../src/components/network/application/n_a_backend.vue"),
      meta: { name: "n_a_backend", requiresAuth: false },
    },
    {
      path: "/network/global",
      component: () => import("../src/components/network/network_global.vue"),
      meta: { name: "network_global", requiresAuth: false },
    },

    // ============ 移动端 users ============
    // 重定向规则
    { path: "/users/index", redirect: "/users/profile" },
    { path: "/users", redirect: "/users/profile" },
    {
      path: "/users/profile",
      component: () => import("../src/components/users/users_profile.vue"),
      meta: { name: "users_profile", requiresAuth: false },
    },
    {
      path: "/users/my_cart",
      component: () => import("../src/components/users/users_my_cart.vue"),
      meta: { name: "users_my_cart", requiresAuth: false },
    },
    {
      path: "/users/my_order",
      component: () => import("../src/components/users/users_my_order.vue"),
      meta: { name: "users_my_order", requiresAuth: false },
    },
    {
      path: "/users/wish_list",
      component: () => import("../src/components/users/users_wish_list.vue"),
      meta: { name: "users_wish_list", requiresAuth: false },
    },
    {
      path: "/users/messages",
      component: () => import("../src/components/users/users_messages.vue"),
      meta: { name: "users_messages", requiresAuth: false },
    },
    {
      path: "/users/address_lists",
      component: () =>
        import("../src/components/users/users_address_lists.vue"),
      meta: { name: "users_address_lists", requiresAuth: false },
    },

    // ============ 移动端 purchase ============
    {
      path: "/purchase/initial_check_out",
      component: () =>
        import("../src/components/purchase/purchase_initial_check_out.vue"),
      meta: { name: "purchase_initial_check_out", requiresAuth: false },
    },
    {
      path: "/purchase/gift_option",
      component: () =>
        import("../src/components/purchase/purchase_gift_option.vue"),
      meta: { name: "purchase_gift_option", requiresAuth: false },
    },
    {
      path: "/purchase/check_out",
      component: () =>
        import("../src/components/purchase/purchase_check_out.vue"),
      meta: { name: "purchase_check_out", requiresAuth: false },
    },
    {
      path: "/purchase/payment_succeed",
      component: () =>
        import("../src/components/purchase/purchase_payment_succeed.vue"),
      meta: { name: "purchase_payment_succeed", requiresAuth: false },
    },
    {
      path: "/purchase/delivery",
      component: () =>
        import("../src/components/purchase/purchase_delivery.vue"),
      meta: { name: "purchase_delivery", requiresAuth: false },
    },

    // ============ 移动端 about ============
    // 重定向规则
    { path: "/about", redirect: "/about/our_story" },
    { path: "/about/index", redirect: "/about/our_story" },
    {
      path: "/about/our_story",
      component: () => import("../src/components/about/about_our_story.vue"),
      meta: { name: "about_our_story", requiresAuth: false },
    },
    {
      path: "/about/our_credo",
      component: () => import("../src/components/about/about_our_credo.vue"),
      meta: { name: "about_our_credo", requiresAuth: false },
    },
    {
      path: "/about/our_mission",
      component: () => import("../src/components/about/about_our_mission.vue"),
      meta: { name: "about_our_mission", requiresAuth: false },
    },
    {
      path: "/about/our_value",
      component: () => import("../src/components/about/about_our_value.vue"),
      meta: { name: "about_our_value", requiresAuth: false },
    },
    {
      path: "/about/our_creations",
      component: () =>
        import("../src/components/about/about_our_creations.vue"),
      meta: { name: "about_our_creations", requiresAuth: false },
    },
    {
      path: "/about/product_faq",
      component: () => import("../src/components/about/about_product_faq.vue"),
      meta: { name: "about_product_faq", requiresAuth: false },
    },

    // ============ 移动端 career ============
    // 重定向规则
    {
      path: "/career/how_to_apply",
      component: () =>
        import("../src/components/career/career_how_to_apply.vue"),
      meta: { name: "career_how_to_apply", requiresAuth: false },
    },
    {
      path: "/career/oppotunities",
      component: () =>
        import("../src/components/career/career_oppotunities.vue"),
      meta: { name: "career_oppotunities", requiresAuth: false },
    },
    {
      path: "/career/what_we_do",
      component: () => import("../src/components/career/career_what_we_do.vue"),
      meta: { name: "career_what_we_do", requiresAuth: false },
    },
    {
      path: "/career/your_own_small_business",
      component: () =>
        import("../src/components/career/career_your_own_small_business.vue"),
      meta: { name: "career_your_own_small_business", requiresAuth: false },
    },

    // ============ 移动端 social ============
    // 重定向规则
    {
      path: "/social/co_communications",
      component: () =>
        import("../src/components/social/social_co_communications.vue"),
      meta: { name: "social_co_communications", requiresAuth: false },
    },

    {
      path: "/social/responsibility",
      component: () =>
        import("../src/components/social/social_responsibility.vue"),
      meta: { name: "social_responsibility", requiresAuth: false },
    },

    // ============ 移动端 global ============
    // 重定向规则
    { path: "/global", redirect: "/global/index" },
    { path: "/global/home", redirect: "/global/index" },
    {
      path: "/global/index",
      component: () => import("../src/components/global/global_index.vue"),
      meta: { name: "global_index", requiresAuth: false },
    },
    {
      path: "/global/saffron",
      component: () => import("../src/components/global/global_saffron.vue"),
      meta: { name: "global_saffron", requiresAuth: false },
    },
    {
      path: "/global/fig",
      component: () => import("../src/components/global/global_fig.vue"),
      meta: { name: "global_fig", requiresAuth: false },
    },
    {
      path: "/global/pistachio",
      component: () => import("../src/components/global/global_pistachio.vue"),
      meta: { name: "global_pistachio", requiresAuth: false },
    },
    {
      path: "/global/order",
      component: () => import("../src/components/global/global_order.vue"),
      meta: { name: "global_order", requiresAuth: false },
    },

    // ============ PC端 ============
    // ============ PC端 home ============
    // 重定向规则
    {
      path: "/pc",
      redirect: "/pc/index",
    },
    {
      path: "/pc/index",
      component: () => import("../src/components_pc/home/home_index.vue"),
      meta: { name: "pc_index", requiresAuth: false },
    },

    // ============ PC端 about ============
    // 重定向规则
    {
      path: "/pc/about",
      redirect: "/pc/about/our_story",
    },
    {
      path: "/pc/about/our_story",
      component: () => import("../src/components_pc/about/our_story.vue"),
      meta: { name: "pc_about_our_story", requiresAuth: false },
    },
    {
      path: "/pc/about/our_credo",
      component: () => import("../src/components_pc/about/our_credo.vue"),
      meta: { name: "pc_about_our_credo", requiresAuth: false },
    },
    {
      path: "/pc/our_missions",
      redirect: "/pc/about/our_mission",
    },
    {
      path: "/pc/about/our_mission",
      component: () => import("../src/components_pc/about/our_mission.vue"),
      meta: { name: "pc_about_our_mission", requiresAuth: false },
    },
    {
      path: "/pc/about/our_creations",
      component: () => import("../src/components_pc/about/our_creations.vue"),
      meta: { name: "pc_about_our_creations", requiresAuth: false },
    },
    {
      path: "/pc/about/our_value",
      component: () => import("../src/components_pc/about/our_value.vue"),
      meta: { name: "pc_about_our_value", requiresAuth: false },
    },

    // ============ PC端 benefit ============
    // 重定向规则
    { path: "/pc/benefit", redirect: "/pc/benefit/index" },
    {
      path: "/pc/benefit/index",
      component: () => import("../src/components_pc/benefit/benefit_index.vue"),
      meta: { name: "pc_benefit_index", requiresAuth: false },
    },
    {
      path: "/pc/benefit/login",
      component: () => import("../src/components_pc/benefit/benefit_login.vue"),
      meta: { name: "pc_benefit_login", requiresAuth: false },
    },
    {
      path: "/pc/benefit/register",
      component: () => import("../src/components_pc/benefit/benefit_register.vue"),
      meta: { name: "pc_benefit_register", requiresAuth: false },
    },

    // ============ PC端 career ============
    // 重定向规则
    {
      path: "/pc/career",
      redirect: "/pc/career/what_we_do",
    },
    {
      path: "/pc/career/index",
      redirect: "/pc/career/what_we_do",
    },
    {
      path: "/pc/career/what_we_do",
      component: () => import("../src/components_pc/career/what_we_do.vue"),
      meta: { name: "pc_career_what_we_do", requiresAuth: false },
    },
    {
      path: "/pc/career/how_to_apply",
      component: () => import("../src/components_pc/career/how_to_apply.vue"),
      meta: { name: "pc_career_how_to_apply", requiresAuth: false },
    },
    {
      path: "/pc/career/opportunities",
      redirect: "/pc/career/oppotunities",
    },
    {
      path: "/pc/career/oppotunities",
      component: () => import("../src/components_pc/career/career_oppotunities.vue"),
      meta: { name: "pc_career_oppotunities", requiresAuth: false },
    },

    // ============ PC端 encouragement ============
    // 重定向规则
    {
      path: "/pc/encouragement",
      redirect: "/pc/encouragement/index",
    },
    {
      path: "/pc/encouragement/index",
      component: () => import("../src/components_pc/encouragement/encouragement_index.vue"),
      meta: { name: "pc_encouragement_index", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/catagory_page",
      component: () => import("../src/components_pc/encouragement/encouragement_catagory_page.vue"),
      meta: { name: "pc_encouragement_catagory_page", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/all",
      component: () => import("../src/components_pc/encouragement/encouragement_all.vue"),
      meta: { name: "pc_encouragement_all", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/sagol_er_1g",
      component: () => import("../src/components_pc/encouragement/goods/goods_sagol_er_1g.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/sagol_er_4g6",
      component: () => import("../src/components_pc/encouragement/goods/goods_sagol_er_4g6.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/reserve_er",
      component: () => import("../src/components_pc/encouragement/goods/goods_reserve_er.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/grind_er",
      component: () => import("../src/components_pc/encouragement/goods/goods_grind_er.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/brew_er",
      component: () => import("../src/components_pc/encouragement/goods/goods_brew_er.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/adas_2g",
      component: () => import("../src/components_pc/encouragement/goods/goods_adas_2g.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },
    {
      path: "/pc/encouragement/goods/adas_4g6",
      component: () => import("../src/components_pc/encouragement/goods/goods_adas_4g6.vue"),
      meta: { name: "pc_encouragement_individual", requiresAuth: false },
    },

    // ============ PC端 daily ============
    // 重定向规则
    {
      path: "/pc/daily",
      redirect: "/pc/daily/index",
    },
    {
      path: "/pc/daily/index",
      component: () => import("../src/components_pc/daily/daily_index.vue"),
      meta: { name: "pc_daily_index", requiresAuth: false },
    },
    {
      path: "/pc/daily/series",
      component: () => import("../src/components_pc/daily/daily_series.vue"),
      meta: { name: "pc_daily_series", requiresAuth: false },
    },
    {
      path: "/pc/daily/play",
      component: () => import("../src/components_pc/daily/daily_play.vue"),
      meta: { name: "pc_daily_play", requiresAuth: false },
    },

    // ============ PC端 global ============
    // 重定向规则
    {
      path: "/pc/global",
      redirect: "/pc/global/index",
    },
    {
      path: "/pc/global/index",
      component: () => import("../src/components_pc/global/global_index.vue"),
      meta: { name: "pc_global_index", requiresAuth: false },
    },
    {
      path: "/pc/global/fig",
      component: () => import("../src/components_pc/global/global_fig.vue"),
      meta: { name: "pc_global_fig", requiresAuth: false },
    },
    {
      path: "/pc/global/pistachio",
      component: () => import("../src/components_pc/global/global_pistachio.vue"),
      meta: { name: "pc_global_pistachio", requiresAuth: false },
    },
    {
      path: "/pc/global/saffron",
      component: () => import("../src/components_pc/global/global_saffron.vue"),
      meta: { name: "pc_global_saffron", requiresAuth: false },
    },
    {
      path: "/pc/global/order",
      component: () => import("../src/components_pc/global/global_order.vue"),
      meta: { name: "pc_global_order", requiresAuth: false },
    },
    // ============ PC端 network ============
    // 重定向规则
    {
      path: "/pc/network",
      redirect: "/pc/network/global",
    },
    {
      path: "/pc/network/index",
      redirect: "/pc/network/global",
    },
    {
      path: "/pc/network/why_eyesunrose",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_index.vue"),
      meta: { name: "pc_network_why_eyesunrose", requiresAuth: false },
    },
    {
      path: "/pc/network/why_eyesunrose/efficient",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_efficient.vue"),
      meta: { name: "pc_n_we_efficient", requiresAuth: false },
    },
    {
      path: "/pc/network/why_eyesunrose/idea",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_idea.vue"),
      meta: { name: "pc_n_we_idea", requiresAuth: false },
    },
    {
      path: "/pc/network/why_eyesunrose/place",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_place.vue"),
      meta: { name: "pc_n_we_place", requiresAuth: false },
    },
    {
      path: "/pc/network/why_eyesunrose/ready",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_ready.vue"),
      meta: { name: "pc_n_we_ready", requiresAuth: false },
    },
    {
      path: "/pc/network/why_eyesunrose/support",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_support.vue"),
      meta: { name: "pc_n_we_support", requiresAuth: false },
    },
    {
      path: "/pc/network/why_eyesunrose/training",
      component: () => import("../src/components_pc/network/why_eyesunrose/n_we_training.vue"),
      meta: { name: "pc_n_we_training", requiresAuth: false },
    },
    {
      path: "/pc/network/apply_to_be_franchisee",
      component: () => import("../src/components_pc/network/network_apply_to_be_franchisee.vue"),
      meta: { name: "pc_network_apply_to_be_franchisee", requiresAuth: false },
    },
    {
      path: "/pc/network/ask_your_questions",
      component: () => import("../src/components_pc/network/network_ask_your_questions.vue"),
      meta: { name: "pc_network_ask_your_questions", requiresAuth: false },
    },
    {
      path: "/pc/network/franchisee_highlights",
      component: () => import("../src/components_pc/network/network_franchisee_highlights.vue"),
      meta: { name: "pc_network_franchisee_highlights", requiresAuth: false },
    },
    // 重定向规则
    { path: "/pc/network/application/form", redirect: "/pc/network/application" },
    { path: "/pc/network/application/index", redirect: "/pc/network/application" },
    {
      path: "/pc/network/application",
      component: () => import("../src/components_pc/network/network_application_forms.vue"),
      meta: { name: "pc_network_application_forms", requiresAuth: false },
    },
    {
      path: "/pc/network/application/newform",
      redirect: "/pc/network/application/new",
    },
    {
      path: "/pc/network/application/formnew",
      redirect: "/pc/network/application/new",
    },
    {
      path: "/pc/network/application/form/new",
      redirect: "/pc/network/application/new",
    },
    {
      path: "/pc/network/application/new",
      component: () => import("../src/components_pc/network/network_application_forms.vue"),
      meta: { name: "pc_n_a_new", requiresAuth: false },
    },
    {
      path: "/pc/network/application/sumit",
      component: () => import("../src/components_pc/network/application/n_a_submit.vue"),
      meta: { name: "pc_n_a_sumit", requiresAuth: false },
    },
    {
      path: "/pc/network/application/track",
      component: () => import("../src/components_pc/network/application/n_a_track.vue"),
      meta: { name: "pc_n_a_track", requiresAuth: false },
    },
    {
      path: "/pc/network/application/backend",
      component: () => import("../src/components_pc/network/application/n_a_backend.vue"),
      meta: { name: "pc_n_a_backend", requiresAuth: false },
    },
    {
      path: "/pc/network/global",
      component: () => import("../src/components_pc/network/network_index.vue"),
      meta: { name: "pc_network_global", requiresAuth: false },
    },

    // ============ PC端 social ============
    // 重定向规则
    {
      path: "/pc/social",
      redirect: "/pc/social/co_communications",
    },
    {
      path: "/pc/social/index",
      redirect: "/pc/social/co_communications",
    },
    {
      path: "/pc/social/co_communications",
      component: () => import("../src/components_pc/social/social_co_communications.vue"),
      meta: { name: "pc_social_co_communications", requiresAuth: false },
    },
    {
      path: "/pc/social/responsibility",
      component: () => import("../src/components_pc/social/social_responsibility.vue"),
      meta: { name: "pc_social_co_responsibility", requiresAuth: false },
    },
  ],
});

// 在路由守卫中添加全局变量，判断是否为PC端
import { isPC } from "../src/utils.js";

// 路由守卫中通过 window.__VUE_APP__ 获取 app 实例，再访问 $isPC
router.beforeEach((to, from, next) => {
  // PC端访问非/pc/开头页面，跳转到/pc/xxx
  if (isPC && !to.path.startsWith("/pc") && to.path !== "/") {
    next("/pc" + to.path);
  }
  // 移动端访问/pc/xxx页面，跳转到/xxx
  else if (isPC === false && to.path.startsWith("/pc/")) {
    next(to.path.replace(/^\/pc/, ""));
  }
  else {
    next();
  }
});

// 对外共享路由的实例对象
export default router;
